// extracted by mini-css-extract-plugin
module.exports = {"container":"exams_container__F2Tn3","next":"exams_next__2Wtxq"};